import { memo } from 'react'
import { withRouter } from 'react-router-dom'
import { sessionStore } from '@/utils/storage'
import CommonFunc from '@/utils/common-func'
import BasicStep from '../BasicStep/BasicStep'
const ReduceStep = ({ history, step }: any) => {
  const LIST = [{ label: '上传内容' }, { label: '选择段落' }, { label: '查看结果' }]
  const onConfirm = (step: number) => {
    const cacheData = sessionStore.get('reduceData', {}) as any
    if (step == 1) {
      const reduceData = CommonFunc.omit(cacheData, ['langeIndex', 'reduceTypes', 'platformIndex', 'selectParagraphs'])
      reduceData.pathname = '/reduce/' + cacheData.type
      sessionStore.set('reduceData', reduceData)
      history.push('/reduce/' + cacheData.type)
    }
  }
  return <BasicStep list={LIST} step={step} isGradient={true} onConfirm={onConfirm} />
}

export default memo(withRouter(ReduceStep))
